function formatWindow(hours) {
  if (hours === 7 * 24) return '7 days';
  if (hours === 24) return '1 day';
  if (hours === 1) return '1 hour';
  if (hours < 1) return `${Math.max(1, Math.round(hours * 60))} minutes`;
  if (hours >= 24 && hours % 24 === 0) return `${hours / 24} days`;
  return `${Math.max(1, Math.round(hours))} hours`;
}

function formatActivityDuration(durationMilliseconds) {
  return formatWindow(durationMilliseconds / (60 * 60 * 1000));
}

module.exports = { formatActivityDuration };
